module.exports = __webpack_public_path__ + "media/queue-pop.09b2bdb3.mp3";